import initializeBasicAuth from "nextjs-basic-auth";

const users = [{ user: "web3akedo", password: "pictoria555" }];

export default initializeBasicAuth({ users });
